<template>
    <b-modal
        v-model="shown"
        centered
        title="Add Package"
        lazy
    >

        <b-container fluid>
            <b-row>
                <b-form-group class="w-100">
                    <div><label>Package</label></div>
                    <Multiselect
                        v-model="selectedPackage"
                        placeholder="Search for a package..."
                        track-by="id"
                        label="name"
                        selected-label=""
                        :options="selectedPackageOptions"
                        :multiple="false"
                        :loading="packageSelectLoading"
                    />
                    <b-form-invalid-feedback :force-show="$v.selectedPackage.$dirty && !$v.selectedPackage.required">
                        Please select a package.
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-row>
            <b-row v-if="selectedPackage && selectedPackage.currency_id">
                <b-form-group class="mb-0 w-100">
                    <b-checkbox v-model="setCurrency" >
                        Set display currency to {{ selectedPackage.currency_id }}
                    </b-checkbox>
                </b-form-group>
            </b-row>
        </b-container>

        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="handleClose"
            >
                Close
            </b-btn>
            <Button
                variant="success"
                :disabled="loading || $v.$invalid"
                :loading="submitLoading"
                @click="handleSubmit"
            >
                Add
            </Button>
        </div>

    </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import required from 'vuelidate/lib/validators/required';
import api from '../_api';

export default {

    components: {
        Multiselect,
    },

    data() {
        return {
            shown: false,
            loading: false,
            packageSelectLoading: false,
            submitLoading: false,
            selectedPackage: {},
            selectedPackageOptions: [],
            setCurrency: false,
        };
    },

    created() {
        this.$eventBus.$on(this.$events.openAddPackageModal, async () => {
            this.reset();
            this.shown = true;
            this.packageSelectLoading = true;
            this.selectedPackageOptions = await api.getPackages();
            this.packageSelectLoading = false;
        });
    },

    validations: {
        selectedPackage: {
            required,
        },
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;
            await this.$store.dispatch('costable/addPackage', { selectedPackageId: this.selectedPackage.id, setCurrency: this.setCurrency });
            this.submitLoading = false;
            this.handleClose();
        },
        handleClose() {
            this.shown = false;
        },
        reset() {
            this.selectedPackage = {};
            this.selectedPackageOptions = [];
            this.$v.$reset();
        },
    },

};
</script>
